import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const handleFieldsetCreate = async (fieldset) => {
  return axios
    .post('manage/fieldsets', fieldset)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleFieldsetEdit = async (formData, id) => {
  return axios
    .put(`/manage/fieldsets/${id}`, formData)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleDestroyFieldset = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/fieldsets/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        let messages = Object.values(error.errors || {}).join('. ');
        notify.alertFailure('Error', messages || 'Something went wrong...');
        callback(error);
      });
  });
};

export const handleCopyFieldset = async (id) => {
  return axios
    .get(`/manage/fieldsets/${id}/copy`)
    .then((res) => {
      notify.success('Fieldset copied!');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

const autoGenerateEmailCaptureDefaults = {
  name: 'Parent Email Fieldset [Auto]',
  comment: '',
  description: '',
  conditional_text: '',
  conditional_type: '',
  public: false,
  title_hidden: false,
};

const autoFieldDefaults = {
  name: 'Parent Email [Auto]',
  display_name: '',
  type: 'text',
  required: false,
  placeholder: '',
  default_value: '',
  help_text: '',
  width: 3,
  validator: 'text',
  char_min: null,
  char_limit: null,
  sort: 0,
  informs_global: false,
  quick_edit: false,
  universal_quick_edit: false,
  unread_quick_edit: false,
  alpha: false,
  file_ext_whitelist: '',
};

export const generateAutoEmailFieldset = async (formID, sortValue) => {
  let field;
  let fieldset = await axios
    .post('manage/fieldsets', {
      ...autoGenerateEmailCaptureDefaults,
      form_id: formID,
      sort: sortValue,
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      notify.failure('Failed to create fieldset...');
      console.error(error.response);
      return error;
    });

  if (fieldset.ok) {
    field = await axios
      .post('manage/fields', {
        ...autoFieldDefaults,
        fieldset_id: fieldset.data.id,
      })
      .then((res) => {
        notify.success('[Auto] Email field generated!');
        return res;
      })
      .catch((error) => {
        notify.failure('Failed to create field...');
        console.error(error.response);
        return error;
      });
  }

  return { fieldset, field };
};
